(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartItems extends HTMLElement {
    connectedCallback() {
      this.quantityTimer = null;

      this.addEventListener('input', (event) => {
        const input = event.target.closest('[data-cart-quantity-input]');
        if (!input) return;

        clearTimeout(this.quantityTimer);
        this.quantityTimer = setTimeout(() => this.changeLine(input), 500);
      });

      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        const input = event.target.closest('[data-cart-quantity-input]');
        if (!input) return;

        event.preventDefault();
        clearTimeout(this.quantityTimer);
        this.changeLine(input);
      });

      this.addEventListener('click', (event) => {
        const removeLink = event.target.closest('[data-cart-remove]');
        if (!removeLink) return;

        event.preventDefault();
        const row = removeLink.closest('[data-cart-line-item]');
        if (row) this.changeLine(row, 0);
      });
    }

    async changeLine(target, quantityOverride) {
      const row = target.closest('[data-cart-line-item]');
      if (!row) return;

      const key = row.dataset.lineKey;
      let quantity = quantityOverride;
      if (quantity === undefined) {
        const input = row.querySelector('[data-cart-quantity-input]');
        quantity = Math.max(0, parseInt(input.value, 10) || 0);
      }

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.classList.add('is-updating');

      try {
        await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity }),
        });

        await this.refresh();
      } catch (error) {
        this.classList.remove('is-updating');
        document.dispatchEvent(
          new CustomEvent('busybee:cart:error', {
            bubbles: true,
            detail: { error },
          })
        );
      }
    }

    async refresh() {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      const [sectionHtml, cartState] = await Promise.all([
        fetch(`${root}cart?section_id=${this.dataset.sectionId}`).then((response) => response.text()),
        fetch(`${root}cart.js`).then((response) => response.json()),
      ]);

      const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const newCartItems = doc.querySelector('cart-items');
      if (newCartItems) {
        this.replaceWith(newCartItems);
      } else {
        this.classList.remove('is-updating');
      }

      document.dispatchEvent(
        new CustomEvent('busybee:cart:count-changed', {
          bubbles: true,
          detail: { count: cartState.item_count },
        })
      );
    }
  }

  if (!customElements.get('cart-items')) {
    customElements.define('cart-items', CartItems);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-collection-sort] select');
    if (!select) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    window.location.href = url.toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const dialogEl = document.getElementById('site-header-mobile-nav');
    if (!dialogEl) return;

    document.querySelectorAll('[data-menu-open]').forEach((button) => {
      button.addEventListener('click', () => {
        if (typeof dialogEl.showModal === 'function') {
          dialogEl.showModal();
        }
      });
    });

    dialogEl.querySelectorAll('[data-menu-close]').forEach((button) => {
      button.addEventListener('click', () => dialogEl.close());
    });

    dialogEl.addEventListener('click', (event) => {
      if (event.target === dialogEl) dialogEl.close();
    });
  })();

  (function () {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    let latestRequest = 0;

    function render(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }

    document.addEventListener('busybee:cart:count-changed', (event) => {
      latestRequest += 1;
      render((event.detail && event.detail.count) || 0);
    });

    /* Quick add, the product form, and the exchange button all announce
       `item-added`, but `cart/add.js` answers with the line item alone, so
       none of them can report the new total. The badge is the header's to
       keep current, so ask the cart for the count here. */
    document.addEventListener('busybee:cart:item-added', async () => {
      latestRequest += 1;
      const request = latestRequest;

      try {
        const response = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return;

        const cart = await response.json();
        /* Two quick adds in a row can resolve out of order; only the newest
           request may paint, or the badge settles on a stale count. */
        if (request !== latestRequest) return;

        render(cart.item_count);
      } catch (error) {
        /* Leave the badge as it stands; the next page load corrects it. */
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (this.slides.length < 2) return;

      this.index = 0;
      this.delay = Number(this.dataset.interval) || 6000;
      this.held = false;
      this.userPaused = false;
      this.pauseButton = this.querySelector('[data-pause]');
      this.pauseButton?.addEventListener('click', () => this.setPaused(!this.userPaused));

      // Rotation is the slideshow's only motion, so it never runs for shoppers
      // who have asked for reduced motion. It also rests while the shopper is
      // pointing at the photo and while the tab is in the background.
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));

      // Touch: a mostly-horizontal drag of 40px or more swipes, and a tap on
      // the photo pauses or resumes.
      this.addEventListener('pointerdown', (event) => {
        this.dragX = event.clientX;
        this.dragY = event.clientY;
      });
      this.addEventListener('pointerup', (event) => {
        if (this.dragX == null) return;
        const dx = event.clientX - this.dragX;
        const dy = event.clientY - this.dragY;
        this.dragX = null;
        if (event.target.closest('[data-pause]')) return;
        const isTap = Math.abs(dx) < 10 && Math.abs(dy) < 10;
        if (isTap && event.pointerType !== 'mouse') {
          this.setPaused(!this.userPaused);
          return;
        }
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        this.go(this.index + (dx < 0 ? 1 : -1));
        this.restart();
      });

      // Theme editor: selecting a Slide block shows that slide and holds it.
      document.addEventListener('shopify:block:select', (event) => {
        const i = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
        if (i === -1) return;
        this.held = true;
        this.stop();
        this.go(i);
      });
      document.addEventListener('shopify:block:deselect', () => {
        this.held = false;
        this.start();
      });

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    go(i) {
      const count = this.slides.length;
      this.index = (i + count) % count;
      this.slides.forEach((slide, n) => {
        const active = n === this.index;
        slide.classList.toggle('is-active', active);
        slide.toggleAttribute('aria-hidden', !active);
      });
    }

    setPaused(paused) {
      this.userPaused = paused;
      if (this.pauseButton) {
        this.pauseButton.setAttribute('aria-pressed', String(paused));
        this.pauseButton.setAttribute(
          'aria-label',
          paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel
        );
      }
      if (paused) {
        this.stop();
      } else {
        this.go(this.index + 1);
        this.start();
      }
    }

    start() {
      if (this.reduceMotion || this.held || this.userPaused || this.timer || document.hidden) return;
      this.timer = setInterval(() => this.go(this.index + 1), this.delay);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('hero-slideshow')) {
    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndlpt-exchange"] && !Shopify.designMode) return;
  try {
    
  class ExchangeJoinButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (this.button) {
        this.button.addEventListener('click', () => this.addToCart());
      }
    }

    async addToCart() {
      const variantId = this.dataset.variantId;
      if (!variantId || !this.button) return;

      this.button.disabled = true;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || 'Unable to add to cart');
        }

        document.dispatchEvent(
          new CustomEvent('busybee:cart:item-added', {
            bubbles: true,
            detail: { item: data },
          })
        );
      } catch (error) {
        document.dispatchEvent(
          new CustomEvent('busybee:cart:error', {
            bubbles: true,
            detail: { error },
          })
        );
      } finally {
        this.button.disabled = false;
      }
    }
  }

  if (!customElements.get('exchange-join-button')) {
    customElements.define('exchange-join-button', ExchangeJoinButton);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    document.addEventListener('click', (event) => {
      const thumbnail = event.target.closest('[data-thumbnail]');
      if (!thumbnail) return;

      const mainImage = document.getElementById('product-main-image');
      const imageUrl = thumbnail.dataset.imageUrl;
      if (mainImage && imageUrl) {
        mainImage.src = imageUrl;
      }

      thumbnail.parentElement.querySelectorAll('[data-thumbnail]').forEach((button) => {
        button.classList.toggle('is-active', button === thumbnail);
      });
    });

    document.addEventListener('change', (event) => {
      const select = event.target.closest('#product-variant-select');
      if (!select) return;

      const form = select.closest('product-add-form');
      const priceEl = form ? form.closest('.product__info')?.querySelector('[data-product-price]') : null;
      const option = select.options[select.selectedIndex];
      if (!priceEl || !option) return;

      const openTag = '{' + '{';
      const closeTag = '}' + '}';
      const format = window.themeMoneyFormat || ('$' + openTag + 'amount' + closeTag);
      const cents = Number(option.dataset.price || 0);
      const amount = (cents / 100).toFixed(2);
      const amountNoDecimals = Math.round(cents / 100).toString();

      priceEl.textContent = format
        .replace(openTag + 'amount_no_decimals' + closeTag, amountNoDecimals)
        .replace(openTag + 'amount_with_comma_separator' + closeTag, amount.replace('.', ','))
        .replace(openTag + 'amount' + closeTag, amount);
    });
  })();

  class ProductAddForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (this.form) {
        this.form.addEventListener('submit', (event) => this.handleSubmit(event));
      }
    }

    async handleSubmit(event) {
      event.preventDefault();
      const button = this.form.querySelector('[type="submit"]');
      if (button) button.disabled = true;

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const formData = new FormData(this.form);

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || 'Unable to add to cart');
        }

        document.dispatchEvent(
          new CustomEvent('busybee:cart:item-added', {
            bubbles: true,
            detail: {
              item: data,
              meshSize: this.dataset.meshSize,
              designSize: this.dataset.designSize,
            },
          })
        );
      } catch (error) {
        document.dispatchEvent(
          new CustomEvent('busybee:cart:error', {
            bubbles: true,
            detail: { error },
          })
        );
      } finally {
        if (button) button.disabled = false;
      }
    }
  }

  if (!customElements.get('product-add-form')) {
    customElements.define('product-add-form', ProductAddForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stitched-by-you"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const modal = document.getElementById('stitched-photo-modal');
    if (!modal) return;

    const imageEl = modal.querySelector('.stitch-modal__image');
    const closeEl = modal.querySelector('.stitch-modal__close');
    const nameEl = modal.querySelector('[data-stitch-project-name]');
    const stitchedByEl = modal.querySelector('[data-stitch-stitched-by]');
    const socialRowEl = modal.querySelector('[data-stitch-social-row]');
    const socialEl = modal.querySelector('[data-stitch-social-handle]');
    const threadsRowEl = modal.querySelector('[data-stitch-threads-row]');
    const threadsEl = modal.querySelector('[data-stitch-threads]');
    const stitchesRowEl = modal.querySelector('[data-stitch-stitches-row]');
    const stitchesEl = modal.querySelector('[data-stitch-stitches]');

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-stitch-trigger]');
      if (!trigger) return;

      const data = trigger.dataset;

      if (data.imageUrl) {
        imageEl.src = data.imageUrl;
        imageEl.alt = data.imageAlt || '';
        imageEl.hidden = false;
      } else {
        imageEl.hidden = true;
      }

      nameEl.textContent = data.projectName || '';
      stitchedByEl.textContent = data.stitchedBy || '';

      socialRowEl.hidden = !data.socialHandle;
      socialEl.textContent = data.socialHandle || '';

      threadsRowEl.hidden = !data.threads;
      threadsEl.textContent = data.threads || '';

      stitchesRowEl.hidden = !data.stitches;
      stitchesEl.textContent = data.stitches || '';

      if (typeof modal.showModal === 'function') {
        modal.showModal();
      }
    });

    closeEl.addEventListener('click', () => modal.close());
    modal.addEventListener('click', (event) => {
      if (event.target === modal) modal.close();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
